import React, { useState } from 'react'
import { useAuth } from '../../context/AuthContext'
import { useTheme } from '../../hooks/useTheme'
import { useDeviceDetection } from '../../hooks/useDeviceDetection'

const DTEsAdmin: React.FC = () => {
  const { colors } = useTheme()
  const { tienePermiso } = useAuth()
  const deviceInfo = useDeviceDetection()

  // Verificar permiso
  if (!tienePermiso('dtes.ver')) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
          <div className="bg-red-50 border border-red-200 rounded-lg p-6">
            <p className="text-red-700 font-semibold">❌ Acceso Denegado</p>
            <p className="text-red-600 mt-2">No tienes permisos para acceder a la gestión de DTEs.</p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-8 px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Gestión de DTEs
          </h1>
          <p className="text-gray-600">
            Visualiza y gestiona documentos tributarios electrónicos
          </p>
        </div>

        {/* Content */}
        <div className="bg-white p-8 rounded-lg shadow-sm border border-gray-200 text-center">
          <p className="text-gray-500">
            Los DTEs se manejan desde la vista de reservas. Selecciona una reserva para ver sus DTEs asociados.
          </p>
        </div>
      </div>
    </div>
  )
}

export default DTEsAdmin
